export const AUTH_SUB_STEP = {
  IDENTIFICATION: 'identification',
  LOGIN: 'login',
  SIGNUP: 'signup',
  FORGOT_PASSWORD: 'forgot-password',
} as const;

export type AuthSubStep = (typeof AUTH_SUB_STEP)[keyof typeof AUTH_SUB_STEP];
